import FadeInBottom from "./FadeInBottom";

export default FadeInBottom;
